 import { CardBlog } from "components/CardBlog";
 import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: Blogs
 */
export function Blogs() {
  console.log("Blogs mounted.");

  CardBlog();

}
